var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.visibilityChange),expression:"visibilityChange"},{name:"resize",rawName:"v-resize",value:(_vm.handleResize),expression:"handleResize"}],tag:"div",staticClass:"scroller",class:_vm.classes},[[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }